import { render } from "./tips-amount.vue?vue&type=template&id=338f3bfd"
import script from "./tips-amount.vue?vue&type=script&lang=js"
export * from "./tips-amount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__